import type { DimensionValue, ViewStyle } from 'react-native'
import type { NormalizedStandings, StandingRow } from '../types/leagueDetail.types'

export type TeamMetricKey = 'scored' | 'conceded' | 'diff'

/** Value backing the ranked bar for the selected metric. */
export function metricValue(row: StandingRow, metric: TeamMetricKey): number {
  if (metric === 'scored') return row.goalsFor
  if (metric === 'conceded') return row.goalsAgainst
  return row.goalDiff
}

/** Flatten multi-group standings to a single team-unique row list (first occurrence wins). */
export function dedupeRows(groups: NormalizedStandings['groups']): StandingRow[] {
  const seen = new Set<string>()
  const out: StandingRow[] = []
  for (const group of groups) {
    for (const row of group.rows) {
      if (seen.has(row.teamId)) continue
      seen.add(row.teamId)
      out.push(row)
    }
  }
  return out
}

/** Dynamic, data-driven bar width — kept out of JSX so the no-inline-styles lint rule passes. */
export function getBarWidthStyle(pct: number): ViewStyle {
  return { width: `${pct}%` as DimensionValue }
}

/** Dynamic accent fill color sourced from a prop/theme value. */
export function getAccentColorStyle(accentColor: string): ViewStyle {
  return { backgroundColor: accentColor }
}
